module.exports = __webpack_public_path__ + "static/media/Less Than I Do.16778532.mp3";